(() => {
  if (customElements.get('featured-collections')) {
    return;
  }

  class FeaturedCollections extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initElements();
      this.attachHandlers();
      this.initNavSlider();
      this.initListsSliders();
    }

    initElements() {
      this.tabsNavButtons = this.querySelectorAll('[data-tab-trigger]');
      this.tabs = this.querySelectorAll('[data-tab]');
      this.activeSliders = [];
    }

    attachHandlers() {
      this.tabsNavButtons.forEach((button) => {
        button.addEventListener('click', this.handleTabButtonClick.bind(this));
      });
    }

    toggleTabButtonActive(button) {
      const targetTab = this.querySelector(`#${button.dataset.tabId}`);

      if (!targetTab) {
        return;
      }
      
      const tabGroup = button.dataset.tabGroup;

      this.tabsNavButtons.forEach((tabsNavButton) => {
        const buttonTargetTab = this.querySelector(`#${tabsNavButton.dataset.tabId}`);
        
        if (
          tabsNavButton.dataset.tabGroup !== tabGroup 
          || (buttonTargetTab.parentElement?.closest('[data-tab]') && !buttonTargetTab.parentElement?.closest('[data-tab]')?.classList.contains('is-active'))) {
          return;
        }

        tabsNavButton.classList.toggle('is-active', button === tabsNavButton);
      });
    }

    handleTabButtonClick(event) {
      event.preventDefault();
      event.stopPropagation();

      this.toggleTabButtonActive(event.target);
      this.toggleTabs(event.target);
    }

    toggleTabs(button) {
      const targetTab = this.querySelector(`#${button.dataset.tabId}`);

      if (!targetTab) {
        return;
      }

      const tabGroup = targetTab.dataset.tabGroup;

      this.tabs.forEach((tab) => {
        if (
          tab.dataset.tabGroup !== tabGroup 
          || (tab.parentElement?.closest('[data-tab]') && !tab.parentElement?.closest('[data-tab]')?.classList.contains('is-active'))) {
          return;
        }

        tab.classList.toggle('is-active', tab === targetTab);
      });

      if (targetTab.getAttribute('data-tab-group') === 'tab') {
        this.destroyAllSliders();
        
        this.initNavSlider();
        this.initListsSliders();
      }
    }

    initListsSliders() {
      const currentTab = this.querySelector('[data-tab][data-tab-group="tab"].is-active');

      if (!currentTab) {
        return;
      }

      const sliders = currentTab.querySelectorAll('[data-slider]');

      sliders.forEach(slider => {
        const sliderOptions = {
          navigation: {
            prevEl: slider.querySelector('.swiper-arrow--prev'),
            nextEl: slider.querySelector('.swiper-arrow--next'),
          },
          slidesPerView: 1,
          spaceBetween: 8,
          loop: true,
          breakpoints: {
            1199: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            600: {
              slidesPerView: 2,
            }
          },
        }

        this.initSlider(slider, sliderOptions);
      });
    }

    initSlider(slider, options) {
      const currentSlider = new Swiper(slider, options);

      this.activeSliders.push(currentSlider);
    }

    initNavSlider() {
      const currentTab = this.querySelector('[data-tab][data-tab-group="tab"].is-active');

      if (!currentTab) {
        return;
      }

      const nav = currentTab.querySelector('[data-nav-slider]');
      const navItems = nav?.querySelectorAll('[data-tab-trigger]');
      const activeItem = nav?.querySelector('.is-active');
      let sliderStartPosition = 0;
      
      if (navItems && activeItem) {
        const activeItemIndex = Array.from(navItems).indexOf(activeItem);

        sliderStartPosition = activeItemIndex < 0 ? 0 : activeItemIndex;
      }

      const sliderOptions = {
        initialSlide: sliderStartPosition,
        slidesPerView: 'auto',
        spaceBetween: 25,
        slideToClickedSlide: true,
        breakpoints: {
          750: {
            spaceBetween: 40,
            slideToClickedSlide: false,
          },
        },
      }

      this.initSlider(nav, sliderOptions);
    }

    destroyAllSliders() {
      this.activeSliders.forEach(slider => slider.destroy());

      this.activeSliders = [];
    }
  }

  customElements.define('featured-collections', FeaturedCollections);
})();
